'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = urlMiddleware;

var _utils = require('../utils');

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable no-param-reassign */

function urlMiddleware() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var urlOrThunk = opts.url || '/graphql';
  var fetchOpts = opts.opts;

  return function (next) {
    return function (req) {
      if (fetchOpts) {
        var headers = fetchOpts.headers,
            otherOpts = _objectWithoutProperties(fetchOpts, ['headers']);

        Object.assign(req, otherOpts);
        if (headers) {
          Object.assign(req.headers, headers);
        }
      }

      if (req.relayReqType !== 'batch-query') {
        req.url = (0, _utils.isFunction)(urlOrThunk) ? urlOrThunk(req) : urlOrThunk;
      }

      return next(req);
    };
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/react-relay-network-layer/lib/middleware/url.js
// module id = 1516
// module chunks = 0